import { GetTimeSetsQueryParamsType } from '@/common/queries/getTimeSets/getTimeSetsQuery.type';
import { getTimeSetsFunction } from '@/common/queries/getTimeSets/getTimeSetsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getTimeSetsQueryOptions = (params: GetTimeSetsQueryParamsType) => {
  return queryOptions({
    queryKey: ['getTimeSetsQueryOptions', params],
    queryFn: () => getTimeSetsFunction(params),
    enabled: params?.enableGetFileList,
    select: (data) => {
      return data?.filter(
        (item) => item?.phone_number && (item?.first_name || item?.last_name),
      );
    },
  });
};
